import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import { fetchData, deleteData, activateData, fetchhistory, updateData, fetchEngineerStockDetails, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import Button from '@mui/material/Button';
import { FaTimes, FaExclamationTriangle } from 'react-icons/fa';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { useHistory, useParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { Fragment } from 'react';
import { IconButton, Tooltip, TableCell, Modal, Box } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SaveIcon from '@mui/icons-material/Save';
import DoneIcon from '@mui/icons-material/Done';
import AddIcon from '@mui/icons-material/Add';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import MenuIcon from '@mui/icons-material/Menu'; // Add this import statement
import { FaExclamationCircle } from 'react-icons/fa';
import { FaEdit } from 'react-icons/fa'; // Import edit icon from react-icons library
import DataSaverOffIcon from '@mui/icons-material/DataSaverOff';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonCircleQuestion } from '@fortawesome/free-solid-svg-icons';

const UpdateRequest = () => {
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, logout, userId, token } = useAuth();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [workTypeOptions, setWorkTypeOptions] = useState([]);
    const [selectedWorkStatus, setSelectedWorkStatus] = useState("");
    const [formData, setFormData] = useState({
        RequestID: '',
        CompanyID: '',
        WarrentyStatusID: '',
        workstatus: '',
        CustomerID: '',
        customer: '',
        Product: '',
        ServiceRequestTypes: '',
        warranty: '',
        StaffAppointmentID: '',
        Remarks: '',
        address: '',
        email: '',
        landmark: '',
        number: '',
        contactperson: '',
        customertype: '',
        pincode: '',
        invoiceItems: '',
        EngRemarks: '',
    });


    useEffect(() => {
        fetchRequestDetails();
    }, []);

    const [CustomerID, setCustomerID] = useState('');
    const [invoiceItems, setInvoiceItems] = useState([]);

    const fetchRequestDetails = async () => {
        try {
            const response = await fetchData('ScheduleServiceApi', `/RequestDetails/${id}`, token);
            if (response.responseCode === '1111') {
                const responseData = response.response_data;
                const invoiceItems = responseData.invoiceItems || [];
                const usedItemCount = invoiceItems.length; // Calculate the count of used items

                // Update state with response data and used item count
                setFormData({
                    ...responseData,
                    invoiceItems: invoiceItems,
                    usedItemCount: usedItemCount // Add used item count to formData
                });
                setCustomerID(responseData.customerID);
                console.log(response);
            }
        } catch (error) {
            console.error('Error fetching Request Details:', error);
        }
    };

    useEffect(() => {
        setSelectedWorkStatus(formData.workstatus);
    }, [formData.workstatus]);

    const [Remark, setRemark] = useState('');
    const [editedCallNo, setEditedCallNo] = useState('');
    const [historys, sethistorys] = useState([]);


    const fetchserviceDetails = async () => {
        try {
            const response = await fetchhistory('EngineerVisitApi', companyId, CustomerID, token);
            if (response.responseCode === '1111') {
                sethistorys(response.response_data);
                console.log(response);
            } else {
                console.error('Error fetching Request Details:', response.ErrorMessage);
            }
        } catch (error) {
            console.error('Error fetching Request Details:', error);
        }
    };

    useEffect(() => {
        if (companyId && CustomerID && token) {
            fetchserviceDetails();
        }
    }, [companyId, CustomerID, token]);



    const [showTable, setShowTable] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const closeModal = () => {
        setShowModal(false);
    };

    const handleHistoryClick = () => {
        console.log("History button clicked");
        if (showTable) {
            setShowTable(false);
        } else {
            fetchserviceDetails();
            setShowModal(true);
        }
    };

    const [selectedSpareparts, setSelectedSpareparts] = useState([]);
    const [itemList, setItemList] = useState([]);
    // const [itemCount, setItemCount] = useState(0); // Add the listed item count
    const [itemCount, setItemCount] = useState(itemList.length);
    const [selectedOption, setSelectedOption] = useState('product');


    const [selectedSparepart, setSelectedSparepart] = useState('');
    const [sparepartsOptions, setSparepartsOptions] = useState([]);
    const [SpareID, setSpareID] = useState('');
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchEngineerStockDetails('EngineerStockApi', companyId, userId, token);
                if (response.responseCode === '1111') {
                    const firstSparepart = response.response_data[0];
                    if (firstSparepart) {
                        setSparepartsOptions(response.response_data);
                        setSpareID(firstSparepart.id);
                        console.log(response.response_data);
                    }
                }
            } catch (error) {
                console.error('Error occurred while fetching data:', error);
            }
        };

        fetchData();
    }, [companyId, userId, token]);

    //sale 
    // Add state variables for additional fields

    const AddtoListdata = (e) => {
        e.preventDefault();

        const updatedItem = { ...newItem };

        // Check if SpareParts is selected
        if (!newItem.Name) {
            // Handle the case where no spare parts are selected
            console.log('No spare parts selected');
            return; // Or you can return, skip adding item, etc.
        }

        const discount = 0;
        const amount = newItem.quantity * newItem.SaleRate;
        updatedItem.Amount = amount;
        const netAmount = amount - discount;
        updatedItem.NetAmount = netAmount;
        const gstAmount = (updatedItem.NetAmount * newItem.GSTRate) / 100;
        const cgstAmount = gstAmount / 2;
        const sgstAmount = gstAmount / 2;
        updatedItem.CGSTAmount = cgstAmount;
        updatedItem.SGSTAmount = sgstAmount;
        const totalAmount = netAmount + gstAmount;
        updatedItem.TotalAmount = totalAmount;

        // Add updated item to the list
        setItemList([...itemList, updatedItem]);
        setItemCount(itemCount + 1); // Increment the item count

        // Resetting fields to initial values
        setNewItem({
            Name: '',
            Code: '', // newly added 19/7/24
            SaleRate: 0,
            GSTRate: 0,
            quantity: 1,

            ...(selectedOption === 'spare' && { SpareParts: selectedSpareparts })
        });

        setSelectedSpareparts('');
        setservicerate('');
    };



    const handleSpareTypeChange = (e) => {
        const selectedSpare = e.target.value;
        const foundSpare = sparepartsOptions.find(spare => spare.spareName === selectedSpare);
        if (foundSpare) {
            setSelectedSpareparts(selectedSpare);
            const updatedItem = {
                ...newItem,
                Name: selectedSpare,
                Code: foundSpare.code,
                SaleRate: foundSpare.saleRate || servicerate,
                SparepartsID: foundSpare.id,
                GSTRate: foundSpare.gstRate
            };
            setNewItem(updatedItem);
        }
    };

    const [newItem, setNewItem] = useState({
        Name: '',
        Code: '',
        SaleRate: 0,
        GST: 0,
        quantity: 1,
        // Amount : quantity * SaleRate
    });

    const [Discount, setDiscount] = useState(0);
    //calculation 
    const TotalnetAmount = itemList.reduce((acc, item) => acc + item.NetAmount, 0);
    const TotaltotalAmount = itemList.reduce((acc, item) => acc + item.TotalAmount, 0) - Discount;
    const TotalSaleAmount = itemList.reduce((acc, item) => acc + item.Amount, 0);
    //const balanceAmount = totalAmount - PaidAmount;

    const sgst = itemList.reduce((acc, item) => acc + item.SGSTAmount, 0)
    const cgst = itemList.reduce((acc, item) => acc + item.CGSTAmount, 0)

    const [isSpareModalOpen, setIsSpareModalOpen] = useState(false);

    const handleSpareButtonClick = () => {
        setIsSpareModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsSpareModalOpen(false);
    };

    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
            setItemList(updatedItemList);
            setItemCount(updatedItemList.length);
            closeConfirmDialog();
        }
    };
    // For Final SUmbit
    const handleInvoiceItemSubmit = async () => {
        try {

            const invoiceItems = itemList.map(item => {

                return {
                    EngineerVisitID: formData.requestID,
                    CustomerID: formData.customerID,
                    CompanyID: companyId,
                    Spare: item.Name,
                    Rate: item.SaleRate,
                    DiscountAmount: 0,
                    DiscountPer: 0,
                    Quantity: item.quantity,
                    GSTRate: item.GSTRate,
                    Amount: item.Amount,
                    CGSTAmount: item.CGSTAmount,
                    SGSTAmount: item.SGSTAmount,
                    IGSTAmount: item.IGSTAmount,
                    TotalAmount: item.TotalAmount,
                    NetAmount: item.NetAmount,
                    IsWarrenty: 3, // Assuming this logic is correct for your business logic
                    BilledDate: new Date(),
                    CreatedBy: userId,
                    CreatedDate: new Date(),
                };
            });

            const EngineerMaster = {
                ID: formData.requestID,
                CustomerID: formData.customerID,
                CompanyID: companyId,
                Remarks: Remark,
                Remarks: formData.engRemarks,
                CompanyCallNo: editedCallNo || null,
                WorkStatusID: 4,
                BillStatusID: null,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            const saleMaster = {
                ID: formData.saleID,
                companyid: companyId,
                EngineerVisitID: formData.requestID,
                CustomerID: formData.customerID,
                BillStatusID: null,
                InvoiceDate: new Date(),
                InvoiceNo: null,
                Amount: TotalSaleAmount,
                NetAmount: TotalnetAmount,
                TotalAmount: TotaltotalAmount,
                CGSTAmount: cgst,
                SGSTAmount: sgst,
                IGSTAmount: 0,
                Roundoff: 0,
                PaidAmount: 0,
                BalanceAmount: 0,
                Discount: 0,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            const CreatedData = {
                visit: EngineerMaster,
                sale: saleMaster,
                invoice: invoiceItems,

            };

            setFormData(prevData => ({
                ...prevData,
                UpdatedBy: 1,
            }));

            postData('InvoicedItemApi', CreatedData, token)
                .then((response) => {
                    console.log('Invoice Created success:', response);
                    history.push('/EngineerWorkStatusIndex');
                    setTimeout(() => {
                        window.location.reload()
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Invoice Create error:', error);
                });
        }
        catch (error) {
            console.error('Invoice Create error:', error);
        }
    };

    // For hold

    const handleInvoiceItemHold = async () => {
        try {


            const invoiceItems = itemList.map(item => {

                return {
                    EngineerVisitID: formData.requestID,
                    CustomerID: formData.customerID,
                    CompanyID: companyId,
                    Spare: item.Name,
                    Rate: item.SaleRate,
                    DiscountAmount: 0,
                    DiscountPer: 0,
                    Quantity: item.quantity,
                    GSTRate: item.GSTRate,
                    Amount: item.Amount,
                    CGSTAmount: item.CGSTAmount,
                    SGSTAmount: item.SGSTAmount,
                    IGSTAmount: item.IGSTAmount,
                    TotalAmount: item.TotalAmount,
                    NetAmount: item.NetAmount,
                    IsWarrenty: 3, // To Pay (Condition If the AMC & Warrenty Only This as a seperation ofor getting the AMC ed or warrented Billpayment items from sale)
                    BilledDate: new Date(),
                    CreatedBy: userId,
                    CreatedDate: new Date(),
                };
            });

            const EngineerMaster = {
                ID: formData.requestID,
                CustomerID: formData.customerID,
                CompanyID: companyId,
                Remarks: Remark,
                Remarks: formData.engRemarks,
                CompanyCallNo: editedCallNo || null,
                WorkStatusID: 3,
                BillStatusID: null,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            const saleMaster = {
                ID: formData.saleID,
                companyid: companyId,
                EngineerVisitID: formData.requestID,
                CustomerID: formData.customerID,
                BillStatusID: null,
                InvoiceDate: new Date(),
                InvoiceNo: null,
                Amount: TotalSaleAmount,
                NetAmount: TotalnetAmount,
                TotalAmount: TotaltotalAmount,
                CGSTAmount: cgst,
                SGSTAmount: sgst,
                IGSTAmount: 0,
                Roundoff: 0,
                PaidAmount: 0,
                BalanceAmount: 0,
                Discount: 0,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            const HoldCreateData = {
                visit: EngineerMaster,
                sale: saleMaster,
                invoice: invoiceItems,

            };


            setFormData(prevData => ({
                ...prevData,
                UpdatedBy: 1,
            }));

            postData('InvoicedItemApi', HoldCreateData, token)
                .then((response) => {
                    console.log('Invoice Created success:', response);
                    history.push('/EngineerWorkStatusIndex');
                    setTimeout(() => {
                        window.location.reload()
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Invoice Create error:', error);
                });
        }
        catch (error) {
            console.error('Invoice Create error:', error);
        }
    };

    const [isUsedItemsModalOpen, setIsUsedItemsModalOpen] = useState(false);
    const [usedItemsData, setUsedItemsData] = useState([]);

    // Function to handle button click and open modal
    const handleUsedItemsButtonClick = () => {

        setIsUsedItemsModalOpen(true);
    };

    const handleBackButtonClick = () => {

        setIsUsedItemsModalOpen(false);
    };

    const handleChange = event => {
        const { name, value } = event.target;
        console.log(name, value);
        setFormData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    const [serviceOptions, setserviceOptions] = useState([]);
    const [selectedservice, setSelectedservice] = useState("");
    const [servicerate, setservicerate] = useState("");

    //add service charge

    useEffect(() => {
        const fetchServiceFeeData = async () => {
            try {
                const tmpType = 0;
                // const response = await fetchData('SparePartsApi', `/${companyId}`);
                const response = await fetchData('SparePartsApi', `/${tmpType}/${companyId}`);
                if (response.responseCode === '1111') {
                    const firstSparepart = response.response_data[0];
                    if (firstSparepart) {
                        setserviceOptions(response.response_data);
                        setSpareID(firstSparepart.id);
                        console.log(response.response_data);
                    }
                }
            } catch (error) {
                console.error('Error occurred while fetching data:', error);
            }
        };

        fetchServiceFeeData();
    }, [companyId, userId, token]);

    const [isContainerOpen, setIsContainerOpen] = useState(false);
    const handleFeeButtonClick = () => {
        setIsContainerOpen(!isContainerOpen);
    };


    const handleModalClose = () => {
        setIsContainerOpen(false);
    };


    const Addservicecharge = () => {
        if (selectedservice && servicerate) {
            const newServiceCharge = {
                Name: selectedservice,
                SaleRate: servicerate,
                quantity: 1,
            };

            const amount = newServiceCharge.quantity * parseFloat(newServiceCharge.SaleRate);
            const discount = 0;
            const netAmount = amount - discount;
            newServiceCharge.Amount = amount;
            newServiceCharge.NetAmount = amount;
            newServiceCharge.CGSTAmount = 0;
            newServiceCharge.SGSTAmount = 0;
            newServiceCharge.TotalAmount = amount;

            setItemList([...itemList, newServiceCharge]);
            setItemCount(itemCount + 1);
            closeModal();
        } else {
            alert("Please select a service and provide a rate before adding.");
        }
    };

    const handleServiceFeeChange = (e) => {
        setSelectedservice(e.target.value);
    };


    // for Additional used spare bill and payment 

    const [isAdditionalSpareModalOpen, setIsAdditionalSpareModalOpen] = useState(false);
    const handleCloseAdditionalModal = () => {
        setIsAdditionalSpareModalOpen(false);
    };

    const handleClosecartModal = () => {
        setShowCartTable(false);
    };

    const handleBillandPaymentButtonClick = () => {
        setIsAdditionalSpareModalOpen(!isAdditionalSpareModalOpen);
    };

    const [newpaymentandbillItem, setNewpaymentandbillItem] = useState({
        Name: '',
        Code: '', // newly added on 19/7/2024
        SaleRate: 0,
        GST: 0,
        quantity: 1,
        // Amount : quantity * SaleRate
    });

    const [itempaymentbillList, setpaymentbillItemList] = useState([]);
    const [itempaymentbillCount, setItempaymentbillCount] = useState(itempaymentbillList.length);

    const AddBillPaymentListdata = (e) => {
        e.preventDefault();

        const updatedpaymentedItem = { ...newpaymentandbillItem };

        const discount = 0;
        const amount = (newpaymentandbillItem.quantity * newpaymentandbillItem.SaleRate);
        updatedpaymentedItem.Amount = amount;
        const netAmount = (amount - discount);
        updatedpaymentedItem.NetAmount = netAmount;
        const gstAmount = ((updatedpaymentedItem.NetAmount * newpaymentandbillItem.GSTRate) / 100);
        const cgstAmount = (gstAmount / 2);
        const sgstAmount = (gstAmount / 2);
        updatedpaymentedItem.CGSTAmount = cgstAmount;
        updatedpaymentedItem.SGSTAmount = sgstAmount;
        const totalAmount = (parseFloat(netAmount) + parseFloat(gstAmount));

        updatedpaymentedItem.TotalAmount = totalAmount;
        // Add updated item to the list
        setpaymentbillItemList([...itempaymentbillList, updatedpaymentedItem]);
        setItempaymentbillCount(itempaymentbillCount + 1); // Increment the item count

        // Resetting fields to initial values
        setNewpaymentandbillItem({
            //SparepartsID :'',
            Name: '',
            Code: '',
            SaleRate: 0,
            GSTRate: 0,
            quantity: 1,

            ...(selectedOption === 'spare' && { SpareParts: selectedSpareparts })
        });

        setSelectedSpareparts('');
        setservicerate('');
    };

    const handleAddSpareTypeChange = (e) => {
        const selectedSpare = e.target.value;
        const foundSpare = sparepartsOptions.find(spare => spare.spareName === selectedSpare);
        if (foundSpare) {
            setSelectedSpareparts(selectedSpare);
            const updatedItem = {
                ...newpaymentandbillItem,
                Name: selectedSpare,
                Code: foundSpare.code,
                SaleRate: foundSpare.saleRate || servicerate,
                SparepartsID: foundSpare.id,
                GSTRate: foundSpare.gstRate
            };

            setNewpaymentandbillItem(updatedItem);
        }
    };


    const [itemToDeleteBillpaymentitemIndex, setItemToDeleteBillpaymentIndex] = useState(null);
    const [confirmedDialogOpen, setConfirmedDialogOpen] = useState(false);

    const openConfirmedDialog = (index) => {
        setItemToDeleteBillpaymentIndex(index);
        setConfirmedDialogOpen(true);
    };

    const closeConfirmedDialog = () => {
        setConfirmedDialogOpen(false);
        setItemToDeleteBillpaymentIndex(null);
    };

    const handleDeleteBillpaymentitem = () => {
        if (itemToDeleteBillpaymentitemIndex !== null) {
            const updatedItemList = itempaymentbillList.filter((_, i) => i !== itemToDeleteBillpaymentitemIndex);
            setpaymentbillItemList(updatedItemList);
            setItempaymentbillCount(updatedItemList.length);
            closeConfirmedDialog();
        }
    };

    //AMC
    const handleBillandPaymentAMCClick = async () => {
        try {


            const invoiceItems = itempaymentbillList.map(item => {

                return {
                    EngineerVisitID: formData.requestID,
                    CustomerID: formData.customerID,
                    CompanyID: companyId,
                    Spare: item.Name,
                    Rate: item.SaleRate,
                    DiscountAmount: 0,
                    DiscountPer: 0,
                    Quantity: item.quantity,
                    GSTRate: item.GSTRate,
                    Amount: item.Amount,
                    CGSTAmount: item.CGSTAmount,
                    SGSTAmount: item.SGSTAmount,
                    IGSTAmount: item.IGSTAmount,
                    TotalAmount: item.TotalAmount,
                    NetAmount: item.NetAmount,
                    IsWarrenty: 2, // AMC BillandPayment Items
                    BilledDate: new Date(),
                    CreatedBy: userId,
                    CreatedDate: new Date(),
                };
            });

            const EngineerMaster = {
                ID: formData.requestID,
                CustomerID: formData.customerID,
                CompanyID: companyId,
                Remarks: Remark,
                Remarks: formData.engRemarks,
                CompanyCallNo: editedCallNo || null,
                WorkStatusID: 3,
                BillStatusID: null,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            const saleMaster = {
                ID: formData.saleID,
                companyid: companyId,
                EngineerVisitID: formData.requestID,
                CustomerID: formData.customerID,
                BillStatusID: null,
                InvoiceDate: new Date(),
                InvoiceNo: null,
                Amount: TotalSaleAmount,
                NetAmount: TotalnetAmount,
                TotalAmount: TotaltotalAmount,
                CGSTAmount: cgst,
                SGSTAmount: sgst,
                IGSTAmount: 0,
                Roundoff: 0,
                PaidAmount: 0,
                BalanceAmount: 0,
                Discount: 0,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            const AMCData = {
                visit: EngineerMaster,
                sale: saleMaster,
                invoice: invoiceItems,

            };


            setFormData(prevData => ({
                ...prevData,
                UpdatedBy: 1,
            }));

            postData('InvoicedItemApi', AMCData, token)
                .then((response) => {
                    console.log('Invoice Created success:', response);
                    history.push(`/UpdateRequest/${formData.requestID}`);
                    setTimeout(() => {
                        window.location.reload()
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Invoice Create error:', error);
                });
        }
        catch (error) {
            console.error('Invoice Create error:', error);
        }
    };

    //Warranty 
    const handleBillandPaymentWarrantyClick = async () => {
        try {


            const invoiceItems = itempaymentbillList.map(item => {

                return {
                    EngineerVisitID: formData.requestID,
                    CustomerID: formData.customerID,
                    CompanyID: companyId,
                    Spare: item.Name,
                    Rate: item.SaleRate,
                    DiscountAmount: 0,
                    DiscountPer: 0,
                    Quantity: item.quantity,
                    GSTRate: item.GSTRate,
                    Amount: item.Amount,
                    CGSTAmount: item.CGSTAmount,
                    SGSTAmount: item.SGSTAmount,
                    IGSTAmount: item.IGSTAmount,
                    TotalAmount: item.TotalAmount,
                    NetAmount: item.NetAmount,
                    IsWarrenty: 1, // Warranty BillandPayment Items
                    BilledDate: new Date(),
                    CreatedBy: userId,
                    CreatedDate: new Date(),
                };
            });

            const EngineerMaster = {
                ID: formData.requestID,
                CustomerID: formData.customerID,
                CompanyID: companyId,
                Remarks: Remark,
                Remarks: formData.engRemarks,
                CompanyCallNo: editedCallNo || null,
                WorkStatusID: 3,
                BillStatusID: null,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            const saleMaster = {
                ID: formData.saleID,
                companyid: companyId,
                EngineerVisitID: formData.requestID,
                CustomerID: formData.customerID,
                BillStatusID: null,
                InvoiceDate: new Date(),
                InvoiceNo: null,
                Amount: TotalSaleAmount,
                NetAmount: TotalnetAmount,
                TotalAmount: TotaltotalAmount,
                CGSTAmount: cgst,
                SGSTAmount: sgst,
                IGSTAmount: 0,
                Roundoff: 0,
                PaidAmount: 0,
                BalanceAmount: 0,
                Discount: 0,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            const WarrantyData = {
                visit: EngineerMaster,
                sale: saleMaster,
                invoice: invoiceItems,

            };


            setFormData(prevData => ({
                ...prevData,
                UpdatedBy: 1,
            }));

            postData('InvoicedItemApi', WarrantyData, token)
                .then((response) => {
                    console.log('Invoice Created success:', response);
                    history.push(`/UpdateRequest/${formData.requestID}`);
                    setTimeout(() => {
                        window.location.reload()
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Invoice Create error:', error);
                });
        }
        catch (error) {
            console.error('Invoice Create error:', error);
        }
    };

    // Function to get the background color based on workstatus
    function getStatusColor(workstatus) {
        switch (workstatus) {
            case 'OnHold':
                // return 'yellow';#BB73E0 and #FF8DDB
                return '#FADBD8';
            case 'Completed':

                // return '#0CCDA3'; // Green
                return '#81BE83'; // Green
            case 'InProgress':
                return '#ECEBBD';
            case 'New':
                return '#ECEBBD';
            default:
                return 'white';
        }
    }

    const [showButtonModal, setShowButtonModal] = useState(false);
    const [showCartTable, setShowCartTable] = useState(false);

    const handleCartButtonClick = () => {
        setShowCartTable(true);
        setShowButtonModal(true);
    };

    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
            handleBackButtonClick();
        }
    };
    const [dataAdded, setDataAdded] = useState(false); // State to track if data is added

    const handleHistoryBackButtonClick = () => {
        setShowModal(false);
    };

    const [isEditing, setIsEditing] = useState(false); // State to track editing mode

    // Function to toggle editing mode
    const toggleEdit = () => {
        setIsEditing(!isEditing);
    };


    const [open, setOpen] = useState(false);
    const [noteData, setNoteData] = useState("");
    const [requesteditems, setRequestedData] = useState("");

    const [customerId, setCustomerId] = useState("");

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleStatusClick = async (Id) => {
        handleOpen();

        try {
            const response = await fetchData('CustomerApi', `/CustomerEdit/${Id}`, token);
            if (response.responseCode === '1111') {
                setFormData(response.response_data);
                setCustomerId(response.response_data.id);
                console.log(response);
                handleOpen();
            }
        } catch (error) {
            console.error('Error occurred while fetching Warranty data:', error);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const updatedFormData = {
            ...formData,
            UpdatedBy: userId,
            CustomerRemark: Remark,
        };


        updateData('AMCApi', `${customerId}`, updatedFormData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };


    return (
        <Fragment>
            <div>
                <div className="w-full max-w-sm container mt-6 mx-auto">

                    <div className='w-full mb-2 flex justify-end' style={{ marginTop: '-15px' }}>

                        {/* <Tooltip title="Request">
                            <Button onClick={handleStatusClick} style={{ color: 'black', fontWeight: 'bolder' }} disabled={isLoading}>
                                <FontAwesomeIcon icon={faPersonCircleQuestion} style={{ marginRight: '8px' }} />{isLoading ? <CircularProgress size={24} color="inherit" /> : "Request"}
                            </Button>
                        </Tooltip> */}

                        {formData.workstatus === "InProgress" && (
                            <Tooltip title="HOLD">
                                <Button onClick={handleInvoiceItemHold} style={{ color: 'darkblue', fontWeight: 'bolder' }} disabled={isLoading}>
                                    <PauseCircleOutlineIcon />{isLoading ? <CircularProgress size={24} color="inherit" /> : "Hold"}
                                </Button>
                            </Tooltip>
                        )}

                        {formData.workstatus === "OnHold" && (
                            <Tooltip title="SAVE">
                                <Button onClick={handleInvoiceItemHold} style={{ color: 'darkgreen', fontWeight: 'bolder' }} disabled={isLoading}>
                                    <SaveIcon />{isLoading ? <CircularProgress size={24} color="inherit" /> : "Save"}
                                </Button>
                            </Tooltip>
                        )}
                        <Tooltip title="FINISHED">
                            <Button onClick={handleInvoiceItemSubmit} style={{ color: 'darkmagenta', fontWeight: 'bolder' }} disabled={isLoading}>
                                <DataSaverOffIcon />{isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"}
                            </Button>
                        </Tooltip>

                        <Tooltip title="Exit">
                            <Link to="/EngineerWorkStatusIndex" style={{ color: 'red', textDecoration: 'none' }}>
                                <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                    EXIT<ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>

                    </div>

                    <div className="bg-transparent rounded-lg shadow-lg p-6" style={{ maxHeight: '600px', overflow: 'auto' }}>
                        <div className='w-full mb-2 flex justify-between items-center'>
                            <Tooltip title="History">
                                <a href="#" onClick={handleHistoryClick} className="tooltip-link">
                                    <h4 className='psheading linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black', marginTop: '-20px' }}>Service</h4>
                                </a>
                            </Tooltip>
                            <div style={{ width: '100%', marginTop: '-20px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <Tooltip title="Menu">
                                    <button onClick={() => setShowButtonModal(!showButtonModal)} style={{ marginRight: '10px', padding: '5px', border: 'none', backgroundColor: 'transparent', cursor: 'pointer' }}>
                                        {/* <MenuIcon style={{ fontSize: 24, color: 'black' }} /> */}
                                        {dataAdded ? <FaExclamationCircle style={{ fontSize: 24, color: 'red' }} /> : <MenuIcon style={{ fontSize: 24, color: 'black' }} />}
                                    </button>
                                </Tooltip>
                            </div>
                        </div>

                        {showButtonModal && (
                            <Modal open={showButtonModal} onClose={() => setShowButtonModal(false)}>
                                <div className="fixed inset-0 flex items-center justify-center z-10" onClick={() => setShowButtonModal(false)}>
                                    <div className="bg-green-100 p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }} onClick={(e) => e.stopPropagation()}>
                                        <h3 className='psheading linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black', marginTop: '20px', color: 'brown' }}>Menu</h3>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-start' }}>

                                            {formData.warranty === 'To Pay' && (
                                                <div className="w-full mb-4 flex justify-end">
                                                    <span style={{ marginRight: '10px', alignSelf: 'center', color: 'black', fontWeight: 'bolder' }}>Add Spare</span>
                                                    <button
                                                        onClick={handleSpareButtonClick}
                                                        style={{
                                                            width: '150px',
                                                            height: '40px',
                                                            backgroundColor: '#07202D',
                                                            border: 'none',
                                                            borderRadius: '7px',
                                                            color: 'white',
                                                            fontSize: '16px',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontWeight: 'bolder'
                                                        }}
                                                    >
                                                        <BuildCircleIcon style={{ color: 'white', marginRight: '5px', fontWeight: 'bolder' }} />
                                                        Spare({itemCount})
                                                    </button>
                                                </div>
                                            )}

                                            {/* Warranty conditions */}

                                            {formData.warranty === 'Warranty' && (
                                                <div className="w-full mb-4 flex justify-end">
                                                    <span style={{ marginRight: '10px', alignSelf: 'center', color: 'black', fontWeight: 'bolder' }}>Additional Spare</span>
                                                    <button
                                                        onClick={handleSpareButtonClick}
                                                        style={{
                                                            width: '150px',
                                                            height: '60px',
                                                            backgroundColor: '#07202D',
                                                            border: 'none',
                                                            borderRadius: '7px',
                                                            color: 'white',
                                                            fontSize: '16px',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontWeight: 'bolder'
                                                        }}
                                                    >
                                                        <BuildCircleIcon style={{ color: 'white', marginRight: '5px', fontWeight: 'bolder' }} />
                                                        Bill & Payments({itemCount})
                                                    </button>
                                                </div>
                                            )}

                                            {formData.warranty === 'AMC' && (
                                                <div className="w-full mb-4 flex justify-end">
                                                    <span style={{ marginRight: '10px', alignSelf: 'center', color: 'black', fontWeight: 'bolder' }}>Add Spare</span>
                                                    <button
                                                        onClick={handleSpareButtonClick}
                                                        style={{
                                                            width: '150px',
                                                            height: '60px',
                                                            backgroundColor: '#07202D',
                                                            border: 'none',
                                                            borderRadius: '7px',
                                                            color: 'white',
                                                            fontSize: '16px',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontWeight: 'bolder'
                                                        }}
                                                    >
                                                        <BuildCircleIcon style={{ color: 'white', marginRight: '5px', fontWeight: 'bolder' }} />
                                                        Bill & Payments({itemCount})
                                                    </button>
                                                </div>
                                            )}

                                            {/* {END} */}
                                            <div className="w-full mb-4 flex justify-end">
                                                <span style={{ marginRight: '10px', alignSelf: 'center', color: 'black', fontWeight: 'bolder' }}>Used Spares</span>
                                                <button
                                                    onClick={handleUsedItemsButtonClick}
                                                    style={{
                                                        width: '150px',
                                                        height: '40px',
                                                        backgroundColor: '#28a745',
                                                        border: 'none',
                                                        borderRadius: '7px',
                                                        color: 'white',
                                                        fontSize: '16px',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontWeight: 'bolder'
                                                    }}
                                                >
                                                    <DoneIcon style={{ color: 'white', marginRight: '5px', fontWeight: 'bolder' }} />
                                                    Used({formData && formData.usedItemCount ? formData.usedItemCount : 0})
                                                </button>
                                            </div>
                                            <div className="w-full mb-4 flex justify-end">
                                                <span style={{ marginRight: '10px', alignSelf: 'center', color: 'black', fontWeight: 'bolder' }}>Service Fee</span>
                                                <button
                                                    onClick={handleFeeButtonClick}
                                                    style={{
                                                        width: '150px',
                                                        height: '40px',
                                                        backgroundColor: '#ffc107',
                                                        border: 'none',
                                                        borderRadius: '7px',
                                                        color: 'white',
                                                        fontSize: '16px',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontWeight: 'bolder'
                                                    }}
                                                >
                                                    <AttachMoneyIcon style={{ color: 'white', marginRight: '5px', fontWeight: 'bolder' }} />
                                                    Fee
                                                </button>
                                            </div>
                                            {formData.warranty === 'Warranty' && (
                                                <div className="w-full mb-4 flex justify-end">
                                                    <span style={{ marginRight: '5px', alignSelf: 'center', color: 'black', fontWeight: 'bolder' }}>Warranty covered Item</span>
                                                    <button
                                                        onClick={handleBillandPaymentButtonClick}
                                                        style={{
                                                            width: '150px',
                                                            height: '40px',
                                                            backgroundColor: '#17a2b8',
                                                            border: 'none',
                                                            borderRadius: '7px',
                                                            color: 'white',
                                                            fontSize: '16px',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontWeight: 'bolder'
                                                        }}
                                                    >
                                                        <ReceiptIcon style={{ color: 'white', marginRight: '5px', fontWeight: 'bolder' }} />
                                                        Warranty Item
                                                    </button>
                                                </div>
                                            )}
                                            {formData.warranty === 'AMC' && (
                                                <div className="w-full mb-4 flex justify-end">
                                                    <span style={{ marginRight: '5px', alignSelf: 'center', color: 'black', fontWeight: 'bolder' }}>AMC Covered Item</span>
                                                    <button
                                                        onClick={handleBillandPaymentButtonClick}
                                                        style={{
                                                            width: '150px',
                                                            height: '40px',
                                                            backgroundColor: '#17a2b8',
                                                            border: 'none',
                                                            borderRadius: '7px',
                                                            color: 'white',
                                                            fontSize: '16px',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontWeight: 'bolder'
                                                        }}
                                                    >
                                                        <ReceiptIcon style={{ color: 'white', marginRight: '5px', fontWeight: 'bolder' }} />
                                                        AMC Item
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        )}

                        {showCartTable && (
                            <Modal open={showCartTable} onClose={() => setShowCartTable(false)}>
                                <div className="fixed inset-0 flex items-center justify-center z-10" onClick={() => setShowCartTable(false)}>

                                    <div className="bg-green-100 p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '100vh', overflowY: 'auto', overflowX: 'auto' }} onClick={(e) => e.stopPropagation()}>
                                        <div className="flex justify-end mt-2" >
                                            <div className="flex justify-end mt-2">
                                                <Tooltip title="Close">
                                                    <button className="absolute bottom-2 right-2 md:static md:mr-2" onClick={handleClosecartModal}>
                                                        <FaTimes />
                                                    </button>
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <br></br>

                                        <h4 className='psheading linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black', marginTop: '-20px', color: 'black', fontWeight: 'bolder' }}>
                                            <ShoppingBasketIcon style={{ color: 'Coral', marginRight: '5px' }} />
                                            Items in Your cart ({itemCount})
                                        </h4>
                                        <div className="w-full mb-4 flex">
                                            <TableContainer component={Paper}>
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Sl.No</th>
                                                            <th>Name</th>
                                                            <th>Qty</th>
                                                            <th>Delete</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {itemList.map((item, index) => (
                                                            <tr key={index}>
                                                                <td className="px-4 py-2 border-r">{index + 1}</td>
                                                                <td className="px-4 py-2 border-r">{item.Name}</td>
                                                                <td className="px-4 py-2 border-r">{item.quantity}</td>
                                                                <td>
                                                                    <Tooltip title="Delete">
                                                                        <DeleteIcon
                                                                            style={{ color: 'violet', cursor: 'pointer', marginLeft: '20px' }}
                                                                            onClick={() => openConfirmDialog(index)}
                                                                        />
                                                                    </Tooltip>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </TableContainer>
                                            <Dialog
                                                open={confirmDialogOpen}
                                                onClose={closeConfirmDialog}
                                                aria-labelledby="alert-dialog-title"
                                                aria-describedby="alert-dialog-description"
                                            >
                                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                                <DialogContent>
                                                    <DialogContentText id="alert-dialog-description">
                                                        Are you sure you want to delete this record?
                                                    </DialogContentText>
                                                </DialogContent>

                                                <DialogActions>
                                                    <button
                                                        onClick={closeConfirmDialog}
                                                        style={{
                                                            backgroundColor: '#dc3545',
                                                            color: '#ffffff',
                                                            border: '1px solid #dc3545',
                                                            borderRadius: '4px',
                                                            padding: '8px 16px',
                                                            cursor: 'pointer',
                                                            marginRight: '8px',
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        onClick={() => handleDelete(itemToDeleteIndex)}
                                                        style={{
                                                            backgroundColor: '#28a745',
                                                            color: '#ffffff',
                                                            border: '1px solid #28a745',
                                                            borderRadius: '4px',
                                                            padding: '8px 16px',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        Confirm
                                                    </button>
                                                </DialogActions>

                                            </Dialog>
                                            {/* </div> */}
                                        </div>

                                    </div>
                                </div>
                            </Modal>
                        )}

                        <br></br>
                        <div className="w-full mb-4"  >
                            <div className="w-full mb-4 p-4  shadow-md rounded-lg" style={{ marginTop: '-50px' }}>
                                <div className="mb-4">
                                    <label className="block text-sm font-semibold mb-2 text-black">Name: <span className="font-normal" style={{ fontSize: '16px' }}>{formData.customer}</span></label>
                                </div>
                                <div className="mb-4" style={{ marginTop: '-15px' }}>
                                    <label className="block text-sm font-semibold mb-2 text-black">PhNo: <span className="font-normal" style={{ fontSize: '16px' }}>{formData.number}</span></label>
                                </div>
                                {
                                    formData.customer_Company === 2 && (
                                        <div>
                                            <div className="mb-4" style={{ marginTop: '-15px' }}>
                                                <label className="block text-sm font-semibold mb-2 text-black">
                                                    Company: <span className="font-normal" style={{ fontSize: '16px' }}>Schneider</span>

                                                </label>
                                                <FaEdit
                                                    className="ml-2 cursor-pointer"
                                                    onClick={toggleEdit}
                                                    style={{ color: '#C34A36' }}

                                                /> <label className="block text-sm font-semibold mb-2 text-black" htmlFor="companyCallNo">CallNo: {formData.companyCallNo}</label>


                                            </div>
                                            {isEditing && (
                                                <div className="mb-4" style={{ marginTop: '-15px', width: '250px' }}>
                                                    <input

                                                        value={editedCallNo}
                                                        onChange={(e) => setEditedCallNo(e.target.value)}
                                                        type="text"
                                                        className="shadow appearance-none border rounded w-full py-3 px-4 text-black leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mt-1"
                                                        style={{ marginTop: '-15px' }}
                                                    />
                                                </div>
                                            )}
                                            <br></br>
                                        </div>
                                    )
                                }

                                {
                                    formData.customer_Company === 3 && (
                                        <div>
                                            <div className="mb-4" style={{ marginTop: '-15px' }}>

                                                <label className="block text-sm font-semibold mb-2 text-black">
                                                    Company: <span className="font-normal" style={{ fontSize: '16px' }}>Brother</span>
                                                    <FaEdit
                                                        className="ml-2 cursor-pointer"
                                                        onClick={toggleEdit}
                                                        style={{ color: '#C34A36' }}

                                                    />
                                                    <label className="block text-sm font-semibold mb-2 text-black" htmlFor="companyCallNo">CallNo: {formData.companyCallNo}</label>

                                                </label>
                                            </div>
                                            {isEditing && (
                                                <div className="mb-4" style={{ marginTop: '-15px', width: '250px' }}>
                                                    <input

                                                        value={editedCallNo}
                                                        onChange={(e) => setEditedCallNo(e.target.value)}
                                                        type="text"
                                                        className="shadow appearance-none border rounded w-full py-3 px-4 text-black leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mt-1"
                                                        style={{ marginTop: '-15px' }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    )
                                }
                                <div className="mb-4" style={{ marginTop: '-15px' }}>
                                    <label className="block text-sm font-semibold mb-2 text-black">Model: <span className="font-normal" style={{ fontSize: '16px' }}>{formData.productModel}</span></label>
                                </div>
                                <div className="mb-4" style={{ marginTop: '-15px' }}>
                                    <label className="block text-sm font-semibold mb-2 text-black">Warranty: <span className="font-normal" style={{ fontSize: '16px' }}>{formData.warranty}</span></label>
                                </div>
                                <div className="mb-4" style={{ marginTop: '-20px' }}>
                                    <label className="block text-sm font-semibold mb-2 text-black">
                                        W.ExpireDate: {' '}
                                        <span className="font-normal" style={{ fontSize: '16px', color: formData.warrentyExpireDate ? 'inherit' : 'red' }}>
                                            {formData.warrentyExpireDate ? new Date(formData.warrentyExpireDate).toLocaleDateString('en-GB') : "Not a AMC Customer"}
                                        </span>
                                    </label>
                                </div>



                                {/* <div className="mb-4" style={{ marginTop: '-15px' }}>
                                    <label className="block text-sm font-semibold mb-2 text-black">Address: <span className="font-normal" style={{ fontSize: '16px' }}>{`${formData.address} - ${formData.landmark}`}</span></label>
                                </div>
                                <div className="mb-4" style={{ marginTop: '-15px' }}>
                                    <label className="block text-sm font-semibold mb-2 text-black">Pin: <span className="font-normal" style={{ fontSize: '16px' }}>{formData.pincode}</span></label>
                                </div> */}

                                <div className="w-full mb-4" style={{ marginTop: '-15px' }}>
                                    <div className="w-full mb-4">
                                        <label className="block tracking-wide text-black text-sm font-bold mb-2" htmlFor="engRemarks">Remark <span style={{ color: 'red' }}>*</span></label>
                                        <textarea
                                            className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            value={formData.engRemarks}
                                            onChange={handleChange}
                                            name="engRemarks"
                                            id="engRemarks"
                                            placeholder="Enter Remarks"
                                            rows={3}
                                            maxLength={250}
                                        />
                                    </div>
                                </div>
                                <div className="w-full mb-4" style={{ marginTop: '-15px' }}>
                                    <label className="block text-sm font-semibold mb-2 text-black">Status: <span className="font-normal">{formData.workstatus}</span></label>
                                </div>
                            </div>


                        </div>

                        <Modal open={showModal} onClose={() => setShowModal(false)} className={showModal ? 'notification-modal' : ''}>
                            <div className="fixed inset-0 flex items-center justify-center z-10" onClick={() => setShowModal(false)}>
                                <div
                                    className="bg-green-100 p-6 rounded-lg shadow-lg"
                                    style={{
                                        width: '1000px',
                                        maxHeight: '80vh',
                                        overflowY: 'auto',
                                        overflowX: 'auto'
                                    }}
                                >
                                    <div className="flex justify-end mt-2">
                                        <Tooltip title="Close">
                                            <button className="absolute bottom-2 right-2 md:static md:mr-2" onClick={handleHistoryBackButtonClick}>
                                                <FaTimes />
                                            </button>
                                        </Tooltip>
                                    </div>

                                    <h4 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'salmon', fontWeight: 'bolder' }}>HISTORY</h4>
                                    <div className="used-items-container">
                                        {historys && historys.length > 0 ? (
                                            historys.map((item, index) => (
                                                <div key={index} className="card" style={{
                                                    backgroundColor: getStatusColor(item.workstatus),
                                                    marginBottom: '10px'
                                                }}>
                                                    <div className="card-body">
                                                        <p style={{ color: 'black' }}><strong>Date: {item.servicedate && new Date(item.servicedate).toLocaleDateString('en-GB')}</strong></p>
                                                        <p style={{ marginTop: '-10px', color: 'black' }}><strong>PDT: {item.productname}</strong></p>
                                                        <p style={{ marginTop: '-10px', color: 'black' }}><strong>Model :{item.modal}</strong></p>
                                                        <p style={{ marginTop: '-10px', color: 'black' }}><strong>Eng:{item.engineerName}</strong></p>
                                                        <p style={{ marginTop: '-10px', color: 'black' }}><strong>Status:{item.workstatus}</strong></p>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="flex items-center justify-center" style={{ marginTop: '20px' }}>
                                                <FaExclamationTriangle style={{ color: '#ff0000', marginRight: '10px' }} />
                                                <p style={{ color: 'black' }}>No data found</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <Modal open={isSpareModalOpen} onClose={handleCloseModal} className={isSpareModalOpen ? 'notification-modal' : ''}>
                            <div className="fixed inset-0 flex items-start justify-center z-10">
                                <div className="bg-green-100 p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '100vh', overflowY: 'auto', overflowX: 'auto' }} onClick={(e) => e.stopPropagation()}>

                                    <div className="flex justify-end mt-2">
                                        <Tooltip title="Close">
                                            <button className="absolute bottom-2 right-2 md:static md:mr-2" onClick={handleCloseModal}>
                                                <FaTimes />
                                            </button>
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <h5 style={{ color: 'brown', textAlign: 'center', fontFamily: 'sans-serif', fontWeight: 'bolder' }}>SPARE LIST</h5>
                                        <div className="w-full mb-4 flex">

                                            <div className="w-1/2 mr-2" style={{ marginLeft: '20px' }}>
                                                <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="spareparts" style={{ fontSize: '16px' }}>
                                                    Spare
                                                </label>
                                                <select
                                                    id="spareparts-dropdown"
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline blackText"
                                                    value={selectedSpareparts}
                                                    onChange={handleSpareTypeChange}
                                                >
                                                    <option value="">--items--</option>
                                                    {sparepartsOptions.map((type) => (
                                                        <option key={type.id} value={type.spareName}>
                                                            {type.spareName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="w-1/6 mr-2">
                                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                                                    Qty
                                                </label>
                                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                    value={newItem.quantity}
                                                    onChange={(e) => setNewItem({ ...newItem, quantity: e.target.value })}

                                                />
                                                {selectedSpareparts && (
                                                    <div className="w-full mb-2 flex justify-end" style={{ marginLeft: '75px', marginTop: '-40px' }}>
                                                        <button
                                                            className="ml-2 bg-blue-500 text-white px-3 py-2 rounded"
                                                            onClick={AddtoListdata}
                                                        >
                                                            ADD
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <br></br>
                                    <h4 className='psheading linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black', marginTop: '-20px', color: 'black', fontWeight: 'bolder' }}>
                                        <ShoppingBasketIcon style={{ color: 'Coral', marginRight: '5px' }} />
                                        Items in Your cart({itemCount})
                                    </h4>
                                    <div className="w-full mb-4 flex">
                                        <TableContainer component={Paper}>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Sl.No</th>
                                                        <th>Code</th>
                                                        <th>Name</th>
                                                        <th>Qty</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {itemList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="px-4 py-2 border-r">{index + 1}</td>
                                                            <td className="px-4 py-2 border-r">{item.Code}</td>
                                                            <td className="px-4 py-2 border-r">{item.Name}</td>
                                                            <td className="px-4 py-2 border-r">{item.quantity}</td>
                                                            <td>
                                                                <Tooltip title="Delete">
                                                                    <DeleteIcon
                                                                        style={{ color: 'violet', cursor: 'pointer', marginLeft: '20px' }}
                                                                        onClick={() => openConfirmDialog(index)}
                                                                    />
                                                                </Tooltip>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </TableContainer>
                                        <Dialog
                                            open={confirmDialogOpen}
                                            onClose={closeConfirmDialog}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                        >
                                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                            <DialogContent>
                                                <DialogContentText id="alert-dialog-description">
                                                    Are you sure you want to delete this record?
                                                </DialogContentText>
                                            </DialogContent>

                                            <DialogActions>
                                                <button
                                                    onClick={closeConfirmDialog}
                                                    style={{
                                                        backgroundColor: '#dc3545',
                                                        color: '#ffffff',
                                                        border: '1px solid #dc3545',
                                                        borderRadius: '4px',
                                                        padding: '8px 16px',
                                                        cursor: 'pointer',
                                                        marginRight: '8px',
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(itemToDeleteIndex)}
                                                    style={{
                                                        backgroundColor: '#28a745',
                                                        color: '#ffffff',
                                                        border: '1px solid #28a745',
                                                        borderRadius: '4px',
                                                        padding: '8px 16px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    Confirm
                                                </button>
                                            </DialogActions>

                                        </Dialog>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </Modal>

                        <Modal open={isUsedItemsModalOpen} onClose={handleBackButtonClick} className={isUsedItemsModalOpen ? 'notification-modal' : ''}>
                            <div className="fixed inset-0 flex items-center justify-center z-10" onClick={handleBackdropClick}>
                                <div
                                    className="bg-green-100 p-6 rounded-lg shadow-lg"
                                    style={{
                                        width: '1000px',
                                        maxHeight: '80vh',
                                        overflowY: 'auto',
                                        overflowX: 'auto'
                                    }}
                                >
                                    <div className="used-items-container">
                                        {formData && formData.invoiceItems && Array.isArray(formData.invoiceItems) && formData.invoiceItems.length > 0 ? (
                                            formData.invoiceItems.map((item, index) => (
                                                <Card key={index} className="card" style={{ backgroundColor: '#BDFCC9' }}>
                                                    <div className="card-body">
                                                        <p><strong>Spare: </strong> {item.spare}</p>
                                                        <p><strong>Qty: </strong>{item.quantity}</p>
                                                    </div>
                                                </Card>
                                            ))
                                        ) : (

                                            <div className="flex items-center">
                                                <FaExclamationTriangle style={{ color: '#ff0000', marginRight: '10px' }} />
                                                <p>No data found</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Modal>


                        <Modal open={isContainerOpen} className={isContainerOpen ? 'notification-modal' : ''}>
                            {/* <div className="fixed inset-0 flex items-start justify-center z-10 ">
                            <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}> */}
                            <div className="fixed inset-0 flex items-start justify-center z-10">
                                <div className="bg-green-100 p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '100vh', overflowY: 'auto', overflowX: 'auto' }} onClick={(e) => e.stopPropagation()}>

                                    <div></div>
                                    <div className="flex justify-end mt-2">
                                        <button className="close-button md:static md:mr-2" onClick={handleModalClose} style={{ marginTop: '-20px' }}>
                                            <Tooltip title="Close">
                                                <FaTimes />
                                            </Tooltip>
                                        </button>
                                    </div>
                                    <h4 style={{ color: 'brown' }}>SERVICE CHARGE</h4>
                                    <div className="w-full mb-4 flex">

                                        <div className="w-full mr-2" style={{ marginLeft: '20px' }}>
                                            <label style={{ fontWeight: 'bolder', color: 'black' }}>Service</label>
                                            <select
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline blackText"
                                                value={selectedservice}
                                                onChange={handleServiceFeeChange}
                                            >
                                                <option value="">--Service--</option>
                                                {serviceOptions.map((type) => (
                                                    <option key={type.id} value={type.name}>
                                                        {type.name}
                                                    </option>
                                                ))}
                                            </select>

                                            <div className="w-1/2 mr-2">
                                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                                                    Rate
                                                </label>
                                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                    value={servicerate}
                                                    //  onChange={(e) => setNewItem({ ...newItem, servicerate: e.target.value })}
                                                    onChange={(e) => {
                                                        const input = e.target.value.replace(/\D/g, '');
                                                        if (input.length <= 5) {
                                                            setservicerate(input);
                                                        }
                                                    }}
                                                />
                                                {/* {selectedservice && ( */}
                                                <div className="w-full mb-2 flex justify-end" style={{ marginLeft: '75px', marginTop: '-40px' }}>
                                                    <button
                                                        className="ml-2 bg-blue-500 text-white px-3 py-2 rounded"
                                                        onClick={Addservicecharge}
                                                    >
                                                        ADD
                                                    </button>
                                                </div>
                                                {/* )} */}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Modal>

                        <Modal open={isAdditionalSpareModalOpen} onClose={handleCloseAdditionalModal} className={isAdditionalSpareModalOpen ? 'notification-modal' : ''}>
                            <div className="fixed inset-0 flex items-start justify-center z-10">
                                <div className="bg-green-100 p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '100vh', overflowY: 'auto', overflowX: 'auto' }} onClick={(e) => e.stopPropagation()}>
                                    <div className="flex justify-end" style={{marginTop:'-5px'}}>

                                        <Tooltip title="Close">
                                            <button className="absolute bottom-2 right-2 md:static md:mr-2" onClick={handleCloseAdditionalModal}>
                                                <FaTimes />
                                            </button>
                                        </Tooltip>
                                    </div>
                                    <div className="flex justify-end mt-2" >

                                        <Tooltip title="Save">
                                            {formData.warranty === 'Warranty' && (
                                                <Button onClick={handleBillandPaymentWarrantyClick} style={{ color: 'darkcyan', fontWeight: 'bolder'}} disabled={isLoading}>
                                                    <SaveIcon />{isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
                                                </Button>
                                            )}
                                            {formData.warranty === 'AMC' && (
                                                <Button onClick={handleBillandPaymentAMCClick} style={{ color: 'darkcyan', fontWeight: 'bolder'}} disabled={isLoading}>
                                                    <SaveIcon />{isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
                                                </Button>
                                            )}
                                        </Tooltip>


                                    </div>

                                    <div>
                                        <h5 style={{ color: 'orangered', textAlign: 'left', fontFamily: 'sans-serif', fontWeight: 'bolder', marginTop: '-45px' }}>BILL & PAYMENTS</h5>
                                        <div className="w-full mb-4 flex">

                                            <div className="w-1/2 mr-2" style={{ marginLeft: '10px' }}>
                                                <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="spareparts" style={{ fontSize: '16px' }}>
                                                    Spare
                                                </label>
                                                <select
                                                    id="spareparts-dropdown"
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline blackText"
                                                    value={selectedSpareparts}
                                                    onChange={handleAddSpareTypeChange}
                                                >
                                                    <option value="">--items--</option>
                                                    {sparepartsOptions.map((type) => (
                                                        <option key={type.id} value={type.spareName}>
                                                            {type.spareName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="w-1/6 mr-2">
                                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                                                    Qty
                                                </label>
                                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                    value={newpaymentandbillItem.quantity}
                                                    onChange={(e) => setNewpaymentandbillItem({ ...newpaymentandbillItem, quantity: e.target.value })}

                                                />
                                                {selectedSpareparts && (
                                                    <div className="w-full mb-2 flex justify-end" style={{ marginLeft: '75px', marginTop: '-40px' }}>
                                                        <button
                                                            className="ml-2 bg-blue-500 text-white px-3 py-2 rounded"
                                                            onClick={AddBillPaymentListdata}
                                                        >
                                                            ADD
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <br></br>
                                    <h4 className='psheading linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black', marginTop: '-20px', color: 'black', fontWeight: 'bolder' }}>
                                        <ShoppingBasketIcon style={{ color: 'Coral', marginRight: '5px' }} />
                                        Items in Your cart({itempaymentbillCount})
                                    </h4>
                                    <div className="w-full mb-4 flex">
                                        <TableContainer component={Paper}>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Sl.No</th>
                                                        <th>Code</th>
                                                        <th>Name</th>
                                                        <th>Qty</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {itempaymentbillList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="px-4 py-2 border-r">{index + 1}</td>
                                                            <td className="px-4 py-2 border-r">{item.Code}</td>
                                                            <td className="px-4 py-2 border-r">{item.Name}</td>
                                                            <td className="px-4 py-2 border-r">{item.quantity}</td>
                                                            <td>
                                                                <Tooltip title="Delete">
                                                                    <DeleteIcon
                                                                        style={{ color: 'violet', cursor: 'pointer', marginLeft: '20px' }}
                                                                        onClick={() => openConfirmedDialog(index)}
                                                                    />
                                                                </Tooltip>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </TableContainer>
                                        <Dialog
                                            open={confirmedDialogOpen}
                                            onClose={closeConfirmedDialog}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                        >
                                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                            <DialogContent>
                                                <DialogContentText id="alert-dialog-description">
                                                    Are you sure you want to delete this record?
                                                </DialogContentText>
                                            </DialogContent>

                                            <DialogActions>
                                                <button
                                                    onClick={closeConfirmedDialog}
                                                    style={{
                                                        backgroundColor: '#dc3545',
                                                        color: '#ffffff',
                                                        border: '1px solid #dc3545',
                                                        borderRadius: '4px',
                                                        padding: '8px 16px',
                                                        cursor: 'pointer',
                                                        marginRight: '8px',
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    onClick={() => handleDeleteBillpaymentitem(itemToDeleteBillpaymentitemIndex)}
                                                    style={{
                                                        backgroundColor: '#28a745',
                                                        color: '#ffffff',
                                                        border: '1px solid #28a745',
                                                        borderRadius: '4px',
                                                        padding: '8px 16px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    Confirm
                                                </button>
                                            </DialogActions>

                                        </Dialog>

                                    </div>

                                </div>

                            </div>
                        </Modal>


                        {/* Appointment Summary by Current and selected date*/}
                        <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-title"
                            aria-describedby="modal-description"
                        >
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    bgcolor: 'background.paper',
                                    border: '2px solid #000',
                                    boxShadow: 24,
                                    p: 4,
                                    width: '700px'
                                }}
                            >
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Tooltip title="Update">
                                        <Button
                                            onClick={handleSubmit}
                                            style={{ color: 'green', fontWeight: 'bolder' }}
                                            disabled={isLoading}
                                        >
                                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
                                        </Button>
                                    </Tooltip>
                                </div>
                                <h5 style={{ textAlign: 'center', color: 'darkblue' }}>Request</h5>
                                <br></br>
                                <div className="w-full mb-4 flex">
                                    <div className="w-1/2 mr-2">
                                        <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
                                            Name
                                        </label>

                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            name="customerName"
                                            value={formData.customer}
                                            onChange={handleChange}
                                            type="text"
                                            placeholder="Enter Name"
                                            disabled
                                        />
                                    </div>
                                    <div className="w-1/4 mr-2">
                                        <label className="block tracking-wide text-black text-base  mb-2" htmlFor="number">
                                            Number
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            name="number"
                                            value={formData.number}
                                            onChange={handleChange}
                                            type="text"
                                            placeholder="Enter Contact Number"
                                            disabled
                                        />
                                    </div>
                                    <div className="w-1/2 mr-2">
                                        <label
                                            className="block tracking-wide text-black text-xs mb-2 mr-4"
                                            htmlFor="productModel"
                                            style={{ fontSize: '15px' }}
                                        >
                                            Product Model
                                        </label>
                                        <input

                                            name="productModel"
                                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                            value={formData.productModel}
                                            onChange={handleChange}
                                            disabled
                                        />
                                    </div>
                                </div>

                                <div className="w-full mb-4 flex">
                                    <div className="w-1/2 mr-2">
                                        <label
                                            className="block tracking-wide text-black text-xs mb-2 mr-4"
                                            htmlFor="renewalExpireDate"
                                            style={{ fontSize: '15px', fontWeight: 'bolder' }}
                                        >
                                            Request Items
                                        </label>
                                        <input

                                            name="renewalExpireDate"
                                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                            value={requesteditems}
                                            onChange={(e) => setRequestedData(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="w-full mb-4 flex">
                                    <div className="w-full mr-1">
                                        <label className="block tracking-wide text-black text-xs mb-2" htmlFor="noteData" style={{ fontSize: '16px' }}>
                                            Note
                                        </label>
                                        <textarea
                                            id="noteData"
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            value={noteData}
                                            onChange={(e) => setNoteData(e.target.value)}
                                            placeholder="Enter Note"
                                            rows={3}
                                            maxLength={250}
                                        />
                                    </div>
                                </div>
                            </Box>
                        </Modal>


                    </div>

                </div >

            </div>
        </Fragment >
    );
}

export default UpdateRequest;

